import React, { useMemo } from 'react';
import { Avatar } from '@mantine/core';
import * as jdenticon from 'jdenticon';

interface AvatarWithFallbackProps {
  imageUrl: string | null;
  seedId: string;
  size?: number;
}

export default function AvatarWithFallback({ imageUrl, seedId, size = 40 }: AvatarWithFallbackProps): JSX.Element {
  const fallbackSvg = useMemo((): string | null => {
    if (imageUrl !== null) {
      return null;
    }
    const svg = jdenticon.toSvg(seedId, size);
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
  }, [imageUrl, seedId, size]);

  return <Avatar src={imageUrl ?? fallbackSvg ?? undefined} size={size} radius="xl" />;
}
